import React from "react";
import { useTranslation } from "react-i18next";

const Modal = ({ downloadXMLUrl, downloadFileName }) => {
  const { t } = useTranslation();

  return (
    <div
      className="modal fade"
      id="forceExport"
      tabindex="-1"
      aria-labelledby="forceExportLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="forceExportLabel">
              {t("forceExportModal.title")}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p>{t("forceExportModal.text1")}</p>
            <p>{t("forceExportModal.text2")}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {t("forceExportModal.closeButton")}
            </button>
            <a
              type="button"
              className="btn btn-primary"
              href={downloadXMLUrl}
              download={downloadFileName}
            >
              {t("forceExportModal.forceExportButton")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
